module.exports = "/static/js/03286c18a43a4eb58c23670a19957c7c.jpg";